import { Check } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { STATO_FASE } from "@/lib/constants";
import { RoleBadge, StatusBadge } from "@/components/Badges";

export function PhaseTracker({ pratica, onUpdated, tasks, docs }) {
  const setStato = async (key, stato) => {
    try {
      const { data } = await api.patch(`/pratiche/${pratica.id}/fasi/${key}`, { stato });
      onUpdated({ ...pratica, fasi: data });
      toast.success("Fase aggiornata");
    } catch (err) { toast.error(formatApiError(err)); }
  };
  const next = { da_iniziare: "in_corso", in_corso: "completata", completata: "da_iniziare" };
  const nextLabel = { da_iniziare: "Avvia fase", in_corso: "Segna completata", completata: "Riapri" };

  return (
    <ol className="relative border-l border-slate-200 ml-3 space-y-6" data-testid="phase-tracker">
      {pratica.fasi.map((f, i) => {
        const t = tasks.filter((x) => x.fase === f.key); const d = docs.filter((x) => x.fase === f.key);
        const tDone = t.filter((x) => x.stato === "completato").length;
        const dOk = d.filter((x) => x.stato !== "mancante").length;
        const done = f.stato === "completata";
        return (
          <li key={f.key} className="ml-6 fade-up" style={{ animationDelay: `${i * 50}ms` }} data-testid={`phase-${f.key}`}>
            <span className={`absolute -left-3 flex h-6 w-6 items-center justify-center rounded-full border-2 text-xs font-semibold ${done ? "bg-emerald-600 border-emerald-600 text-white" : f.stato === "in_corso" ? "bg-white border-[#003087] text-[#003087]" : "bg-white border-slate-300 text-slate-400"}`}>
              {done ? <Check size={13} strokeWidth={3} /> : i + 1}
            </span>
            <div className="bg-white border border-slate-200 rounded-xl p-5">
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <h3 className="font-heading font-medium text-slate-900">{f.nome}</h3>
                  <p className="text-sm text-slate-500 mt-0.5">{f.descrizione}</p>
                  <div className="flex flex-wrap gap-1.5 mt-3">{f.ruoli.map((r) => <RoleBadge key={r} role={r} />)}</div>
                </div>
                <div className="flex flex-col items-end gap-2">
                  <StatusBadge map={STATO_FASE} value={f.stato} testId={`phase-${f.key}-status`} />
                  <button onClick={() => setStato(f.key, next[f.stato])} data-testid={`phase-${f.key}-toggle`} className="text-xs font-medium text-[#003087] hover:underline">{nextLabel[f.stato]}</button>
                </div>
              </div>
              <div className="flex gap-6 mt-4 text-xs text-slate-500">
                <span>Task <strong className="text-slate-800">{tDone}/{t.length}</strong></span>
                <span>Documenti <strong className="text-slate-800">{dOk}/{d.length}</strong></span>
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
